import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "deositPOP_container" }
const _hoisted_2 = { class: "iframe-wrapper" }
const _hoisted_3 = ["src"]

import { ref } from 'vue'
import { useI18n } from 'vue-i18n';
import CustomHeader from '../../components/common/customHeader.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'QRPopup',
  setup(__props, { expose: __expose }) {

const { t } = useI18n();
const show = ref(false)
const iframeUrl = ref('')
const open = (url : any) => {
    show.value = true
    iframeUrl.value = url
}
const close = () => {
    show.value = false
}
__expose({
    open,
    close
})

return (_ctx: any,_cache: any) => {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    position: "bottom",
    "overlay-style": { overflow: 'hidden' },
    style: {
        minWidth: '100%',
        minHeight: '90%',
        color: '#fff',
        zIndex: '2011'
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(CustomHeader, {
          text: "",
          isPopupCloseBackIcon: true,
          onClosePopup: close
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("iframe", {
            src: iframeUrl.value,
            frameborder: "0"
          }, null, 8, _hoisted_3)
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})